 // Body load opacity
$(window).on("load",(function(){ 
   setTimeout(function() {
   $(".product-slideshow + .slideshow-controls, .media_count").css('opacity', '1');
      }, 1000);
 }));

$(document).ready(function(){

  /*
if ($(".acc_box_Ingredients").hasClass("empty_content")) {
       $('.ingredients_list').addClass('hide');
    }

  var hideingredients = $('.not-in-quickbuy').find('.product-detail-accordion');
if(hideingredients.length) {    
} else {
  $('.ingredients_list').addClass('hide');
}*/




  
 $(".product-detail-accordion").insertAfter(".product-description");
 $(".ingredients_list").insertAfter(".product-description");
  $(".acc_box_Ingredients").insertAfter(".ingredients_list");
   
 
    
    setTimeout(function() {

      $(".product-detail .gallery .slick-dots, .media_count").css("opacity", "1");
$(".product-slideshow .slick-dots").insertAfter(".media_count span");
               
 $(".section-product-recommendations").css('opacity', '1');
      
 var owl = $('.product-recommendslider');
      owl.owlCarousel({
        margin: 20,
        loop: true,
        responsive: {
          0: {
            items: 2
          },
          600: {
            items: 3
          },
          1000: {
            items: 5
          }
        }
      })
     }, 1500);
});


 setTimeout(function() {
$('#shopify-section-template--17311950733511__recommendations .product-recommendations .add-cart').on('click', function () {
  setTimeout(function() {
    $("#added-box-wrapper").addClass('show_bag'); 
      $(".blk_tras").addClass('active');
       $("body").addClass('no_scroll'); 
    }, 1000);
  $('#products-recommended-upsells').removeClass("active");
    
});
   }, 1600);


$('.ingredients_list a').on('click', function () {
  // $('.Ingredients_section').trigger("click");    

  $('.acc_box_Ingredients').slideToggle();
});


// text hover image show

const cursor = document.querySelector(".lycursor");
const cursorMedias = document.querySelectorAll(".cursor__media");
const navLinks = document.querySelectorAll(".item_li");

if (cursor) {
  gsap.set(cursor, {
    xPercent: -0,
    yPercent: -47,
    scale: 0 });


  const setCursorX = gsap.quickTo(cursor, "x", {
    duration: 0.6,
    ease: "expo" });


  const setCursorY = gsap.quickTo(cursor, "y", {
    duration: 0.6,
    ease: "expo" });


  window.addEventListener("mousemove", e => {
    setCursorX(e.pageX);
    setCursorY(e.pageY);
  });

  const tl = gsap.timeline({
    paused: true });


  tl.to(cursor, {
    scale: 1,
    opacity: 1,
    duration: 0.5,
    ease: "expo.inOut" });

  navLinks.forEach((navLink, i) => {
    navLink.addEventListener("mouseover", () => {
      cursorMedias[i].classList.add("active");
      tl.play();
    });
  });

  navLinks.forEach((navLink, i) => {
    navLink.addEventListener("mouseout", () => {
      tl.reverse();
      cursorMedias[i].classList.remove("active");
    });
  });

}